import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { devices } from '../../styles/breakpoints';

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  color: ${({ suggested }) =>
    suggested ? colors.BRAND_SECONDARY : colors.GRAY_DARK};
  margin-top: 6px;
  margin-bottom: 6px;
`;

const FlightDate = styled.div`
  font-size: 10px;

  @media ${devices.desktop} {
    font-size: 14px;
  }
`;

const FlightTime = styled.div`
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 2px;

  @media ${devices.desktop} {
    font-size: 22px;
  }
`;

const AirportName = styled.div`
  font-size: 10px;

  @media ${devices.desktop} {
    font-size: 16px;
  }
`;

export default function FlightSchedule({
  flightDate,
  flightTime,
  airportName,
  type,
  suggested
}) {
  return (
    <Container type={type} suggested={suggested}>
      <FlightDate>{flightDate}</FlightDate>
      <FlightTime>{flightTime}</FlightTime>
      <AirportName>{airportName}</AirportName>
    </Container>
  );
}
